import { sample } from 'effector';
import { createAddUserModel } from 'features/add-user';
import { createBlockUserModel } from 'features/block-user';
import { createDeleteUserModel } from 'features/delete-user';
import { createEditUserModel } from 'features/edit-user';
import { createUnblockUserModel } from 'features/unblock-user';
import { createUserRegistryModel } from 'entities/user';
import { accountPageModel } from './account-page-model';

const addUserModel = createAddUserModel();

const editUserModel = createEditUserModel();

const blockUserModel = createBlockUserModel();

const unblockUserModel = createUnblockUserModel();

const deleteUserModel = createDeleteUserModel();

export const userRegistryModel = createUserRegistryModel({
	$accountId: accountPageModel.$accountId,
	onDelete: [deleteUserModel.mutation.finished.success],
	onUpdate: [
		accountPageModel.accountIdSet,
		addUserModel.addUserMutation.finished.success,
		blockUserModel.mutation.finished.success,
		unblockUserModel.mutation.finished.success,
		editUserModel.editUserMutation.finished.success,
		deleteUserModel.mutation.finished.success,
	],
});

sample({
	clock: addUserModel.getAccountsQuery.finished.success,
	source: accountPageModel.$accountId,
	target: addUserModel.form.fields.accountId.setValue,
});

export const accountPageUsersModel = {
	userRegistryModel,
	addUserModel,
	editUserModel,
	blockUserModel,
	unblockUserModel,
	deleteUserModel,
};
